import {
  Dialog,
  DialogActions,
  DialogTitle,
  FormControlLabel,
  Grid,
  Switch
} from "@mui/material";
import { FastField, FieldArray } from "formik";
import {
  MyButton,
  MyMultiSelect,
  MySelect,
  MySelectTime,
  MyTextField,
  MyTextFieldArea
} from "../Lib/componentLibrarys";
import { AddCircleOutline, Check, Close } from "@mui/icons-material";
import { useState } from "react";

export const FormThongTinLichSu = ({
  view,
  values,
  errors,
  setFieldValue,
  thucAnList,
  trangThaiSanXuatList,
  vungSanXuatList
}) => {
  return (
    <div>
      <Grid container spacing={1} style={{ marginTop: "0px" }}>
        <Grid item xs={6}>
          <FastField name="tenThongTinSanXuat">
            {({ field }) => (
              <MyTextField
                required
                disabled={view}
                label="Tên thông tin sản xuất:"
                placeholder="Nhập..."
                errors={errors?.tenThongTinSanXuat}
                helperText={errors?.tenThongTinSanXuat}
                {...field}
              />
            )}
          </FastField>
        </Grid>
        <Grid item xs={6}>
          <FastField name="soLuongAoNuoi">
            {({ field }) => (
              <MyTextField
                disabled={view}
                label="Số lượng ao nuôi:"
                placeholder="Nhập..."
                type="number"
                {...field}
              />
            )}
          </FastField>
        </Grid>
        <Grid item xs={6}>
          <FastField name="dienTichAoNuoi">
            {({ field }) => (
              <MyTextField
                disabled={view}
                label="Diện tích ao nuôi:"
                placeholder="Nhập..."
                type="number"
                {...field}
              />
            )}
          </FastField>
        </Grid>
        <Grid item xs={6}>
          <FastField name="nguonGiong">
            {({ field }) => (
              <MyTextField
                disabled={view}
                label="Nguồn giống:"
                placeholder="Nhập..."
                {...field}
              />
            )}
          </FastField>
        </Grid>
        <Grid item xs={6}>
          <FastField name="soLuongThaGiong">
            {({ field }) => (
              <MyTextField
                disabled={view}
                label="Số lượng thả giống:"
                placeholder="Nhập..."
                type="number"
                {...field}
              />
            )}
          </FastField>
        </Grid>
        <Grid item xs={6}>
          <MySelectTime
            disabled={view}
            label="Ngày thả giống:"
            placeholder="Chọn..."
            value={values?.ngayThaGiong}
            onChange={value => {
              setFieldValue(`ngayThaGiong`, value);
            }}
            width="100%"
          />
        </Grid>
        <Grid item xs={6}>
          <MySelectTime
            disabled={view}
            label="Ngày dự bán:"
            placeholder="Chọn..."
            value={values?.ngayDuBan}
            maxDate={new Date(2050, 12, 31)}
            onChange={value => {
              setFieldValue(`ngayDuBan`, value);
            }}
            width="100%"
          />
        </Grid>
        <Grid item xs={6}>
          <MySelectTime
            disabled={view}
            label="Ngày bán:"
            placeholder="Chọn..."
            value={values?.ngayBan}
            onChange={value => {
              setFieldValue(`ngayBan`, value);
            }}
            width="100%"
          />
        </Grid>
        <Grid item xs={6}>
          <MyMultiSelect
            disabled={view}
            label="Thức ăn:"
            placeholder="Chọn..."
            onChange={(option, value) => {
              setFieldValue(`thucAns`, value);
            }}
            value={values?.thucAns || []}
            options={thucAnList || []}
            name="tenThucAn"
          />
        </Grid>
        <Grid item xs={6}>
          <MyMultiSelect
            disabled={view}
            label="Vùng nuôi:"
            placeholder="Chọn..."
            onChange={(option, value) => {
              setFieldValue(`vungSanXuats`, value);
            }}
            value={values?.vungSanXuats || []}
            options={vungSanXuatList || []}
            name="tenVungSanXuat"
          />
        </Grid>
        <Grid item xs={6}>
          <MySelect
            disabled={view}
            label="Trạng thái sản xuất:"
            placeholder="Chọn..."
            value={values?.trangThaiSX}
            options={trangThaiSanXuatList || []}
            name="ten"
            onChange={(event, value) => {
              setFieldValue(`trangThaiSX`, value);
            }}
          />
        </Grid>
        <Grid item xs={12}>
          <FastField name="ghiChu">
            {({ field }) => (
              <MyTextFieldArea
                label="Ghi chú:"
                placeholder="Nhập..."
                maxRows={3}
                {...field}
                disabled={view}
              />
            )}
          </FastField>
        </Grid>
      </Grid>
    </div>
  );
};

export const FormBenhHai = ({
  view,
  values,
  errors,
  setFieldValue,
  loaiBenhHaiList
}) => {
  const [alert, setAlert] = useState(false);

  return (
    <div>
      <Grid container spacing={1} style={{ marginTop: "0px" }}>
        <Grid
          container
          mt={"-5px"}
          className="capPhep-listInput-container-form"
        >
          <FieldArray
            name="benhHais"
            render={arrayHelpers => (
              <>
                {" "}
                {values?.benhHais?.length > 0 &&
                  values?.benhHais?.map((item, index) => {
                    return (
                      <Grid container spacing={1}>
                        <Grid item xs={12}>
                          <div className="capPhep-listInput-title">
                            Thông tin lần bệnh hại {`thứ ${index + 1}`}{" "}
                            {index > 0 ? (
                              <div
                                className="capPhep-listInput-removeItem"
                                onClick={() => !view && setAlert(index)}
                              >
                                {" "}
                                Xóa{" "}
                              </div>
                            ) : null}{" "}
                          </div>
                        </Grid>
                        <Grid item xs={12}>
                          <MySelect
                            disabled={view}
                            label="Loại bệnh hại:"
                            placeholder="Chọn..."
                            value={values?.benhHais?.[index]?.loaiBenhHai}
                            options={loaiBenhHaiList || []}
                            name="tenBenhHai"
                            onChange={(event, value) => {
                              setFieldValue(
                                `benhHais.[${index}].loaiBenhHai`,
                                value
                              );
                            }}
                          />
                        </Grid>
                        <Grid item xs={6}>
                          <MySelectTime
                            disabled={view}
                            label="Ngày phát bệnh:"
                            placeholder="Chọn..."
                            value={values?.benhHais?.[index]?.ngayPhatBenh}
                            onChange={value => {
                              setFieldValue(
                                `benhHais.[${index}].ngayPhatBenh`,
                                value
                              );
                            }}
                            width="100%"
                          />
                        </Grid>
                        <Grid item xs={6}>
                          <MySelectTime
                            disabled={view}
                            label="Ngày kết thúc:"
                            placeholder="Chọn..."
                            value={values?.benhHais?.[index]?.ngayKetThuc}
                            onChange={value => {
                              setFieldValue(
                                `benhHais.[${index}].ngayKetThuc`,
                                value
                              );
                            }}
                            width="100%"
                          />
                        </Grid>
                        <Grid item xs={12}>
                          <FastField name={`benhHais.[${index}].ghiChu`}>
                            {({ field }) => (
                              <MyTextFieldArea
                                label="Ghi chú:"
                                placeholder="Nhập..."
                                maxRows={3}
                                {...field}
                                disabled={view}
                              />
                            )}
                          </FastField>
                        </Grid>
                        <Grid item xs={6}>
                          <MySelectTime
                            disabled={view}
                            label="Ngày sử dụng:"
                            placeholder="Chọn..."
                            value={values?.benhHais?.[index]?.ngaySuDung}
                            onChange={value => {
                              setFieldValue(
                                `benhHais.[${index}].ngaySuDung`,
                                value
                              );
                            }}
                            width="100%"
                          />
                        </Grid>
                        <Grid item xs={6}>
                          <FastField name={`benhHais.[${index}].mucDichSuDung`}>
                            {({ field }) => (
                              <MyTextField
                                disabled={view}
                                label="Mục đích sử dụng:"
                                placeholder="Nhập..."
                                {...field}
                              />
                            )}
                          </FastField>
                        </Grid>
                        <Grid item xs={12}>
                          <FastField name={`benhHais.[${index}].lieuLuongSuDung`}>
                            {({ field }) => (
                              <MyTextField
                                disabled={view}
                                label="Liều lượng sử dụng:"
                                placeholder="Nhập..."
                                {...field}
                              />
                            )}
                          </FastField>
                        </Grid>
                        <Grid item xs={12}>
                          {values?.benhHais?.length > 0 && (
                            <div className="capPhep-listInput-underlineItem"></div>
                          )}
                        </Grid>
                      </Grid>
                    );
                  })}
                <Dialog
                  open={alert || alert === 0 ? true : false}
                  onClose={() => setAlert(false)}
                  aria-labelledby="alert-dialog-title"
                  aria-describedby="alert-dialog-description"
                >
                  <DialogTitle className="capPhep-listInput-dialog-title">
                    {" "}
                    Bạn chắc chắn muốn xóa thông tin lần bệnh hại này?{" "}
                  </DialogTitle>
                  <DialogActions
                    className="capPhep-listInput-dialog-content"
                    style={{ display: "flex", justifyContent: "center" }}
                  >
                    <MyButton
                      onClick={() => setAlert(false)}
                      txt="Không"
                      color="rgb(192, 44, 64)"
                      className="capPhep-listInput-dialog-buttonClose"
                      icon={<Close />}
                    />
                    <MyButton
                      onClick={() => {
                        arrayHelpers.remove(alert);
                        setAlert(false);
                      }}
                      txt="có"
                      className="capPhep-listInput-dialog-buttonCheck"
                      icon={<Check />}
                    />
                  </DialogActions>
                </Dialog>
                <div
                  className="capPhep-listInput-pushArray"
                  onClick={() =>
                    !view && arrayHelpers.push({
                      loaiBenhHai: null
                    })
                  }
                >
                  <AddCircleOutline className="capPhep-listInput-pushArray-buttonAdd" />{" "}
                  <div>Thêm thông tin lần bệnh hại</div>
                </div>
              </>
            )}
          />
        </Grid>
      </Grid>
    </div>
  );
};

export const FormThongTinBan = ({
  view,
  values,
  errors,
  setFieldValue,
  coSoCheBienList
}) => {
  const [alert, setAlert] = useState(false);

  return (
    <div>
      <Grid container spacing={1} style={{ marginTop: "0px" }}>
        <Grid
          container
          mt={"-5px"}
          className="capPhep-listInput-container-form"
        >
          <FieldArray
            name="thongTinBans"
            render={arrayHelpers => (
              <>
                {" "}
                {values?.thongTinBans?.length > 0 &&
                  values?.thongTinBans?.map((item, index) => {
                    return (
                      <Grid container spacing={1}>
                        <Grid item xs={12}>
                          <div className="capPhep-listInput-title">
                            Thông tin lần bán {`thứ ${index + 1}`}{" "}
                            {index > 0 ? (
                              <div
                                className="capPhep-listInput-removeItem"
                                onClick={() => !view && setAlert(index)}
                              >
                                {" "}
                                Xóa{" "}
                              </div>
                            ) : null}{" "}
                          </div>
                        </Grid>
                        <Grid item xs={6}>
                          <MySelect
                            disabled={view}
                            label="Cơ sở chế biến:"
                            placeholder="Chọn..."
                            value={values?.thongTinBans?.[index]?.coSoCheBien}
                            options={coSoCheBienList || []}
                            name="tenCoSoCheBien"
                            onChange={(event, value) => {
                              setFieldValue(
                                `thongTinBans.[${index}].coSoCheBien`,
                                value
                              );
                            }}
                          />
                        </Grid>
                        <Grid item xs={6}>
                          <FastField name={`thongTinBans.[${index}].tenNguoiBan`}>
                            {({ field }) => (
                              <MyTextField
                                disabled={view}
                                label="Tên người bán:"
                                placeholder="Nhập..."
                                {...field}
                              />
                            )}
                          </FastField>
                        </Grid>
                        <Grid item xs={6}>
                          <FastField name={`thongTinBans.[${index}].soLuongBan`}>
                            {({ field }) => (
                              <MyTextField
                                disabled={view}
                                label="Số lượng bán:"
                                placeholder="Nhập..."
                                type="number"
                                {...field}
                              />
                            )}
                          </FastField>
                        </Grid>
                        <Grid item xs={6}>
                          <MySelectTime
                            disabled={view}
                            label="Ngày bán:"
                            placeholder="Chọn..."
                            value={values?.thongTinBans?.[index]?.ngayBan}
                            onChange={value => {
                              setFieldValue(
                                `thongTinBans.[${index}].ngayBan`,
                                value
                              );
                            }}
                            width="100%"
                          />
                        </Grid>
                        <Grid item xs={12}>
                          <FastField name={`thongTinBans.[${index}].ghiChu`}>
                            {({ field }) => (
                              <MyTextFieldArea
                                disabled={view}
                                label="Ghi chú:"
                                placeholder="Nhập..."
                                maxRows={3}
                                {...field}
                              />
                            )}
                          </FastField>
                        </Grid>
                        <Grid item xs={12}>
                          {values?.thongTinBans?.length > 0 && (
                            <div className="capPhep-listInput-underlineItem"></div>
                          )}
                        </Grid>
                      </Grid>
                    );
                  })}
                <Dialog
                  open={alert || alert === 0 ? true : false}
                  onClose={() => setAlert(false)}
                  aria-labelledby="alert-dialog-title"
                  aria-describedby="alert-dialog-description"
                >
                  <DialogTitle className="capPhep-listInput-dialog-title">
                    {" "}
                    Bạn chắc chắn muốn xóa thông tin lần bán này?{" "}
                  </DialogTitle>
                  <DialogActions
                    className="capPhep-listInput-dialog-content"
                    style={{ display: "flex", justifyContent: "center" }}
                  >
                    <MyButton
                      onClick={() => setAlert(false)}
                      txt="Không"
                      color="rgb(192, 44, 64)"
                      className="capPhep-listInput-dialog-buttonClose"
                      icon={<Close />}
                    />
                    <MyButton
                      onClick={() => {
                        arrayHelpers.remove(alert);
                        setAlert(false);
                      }}
                      txt="có"
                      className="capPhep-listInput-dialog-buttonCheck"
                      icon={<Check />}
                    />
                  </DialogActions>
                </Dialog>
                <div
                  className="capPhep-listInput-pushArray"
                  onClick={() =>
                    !view && arrayHelpers.push({
                      loaiBenhHai: null
                    })
                  }
                >
                  <AddCircleOutline className="capPhep-listInput-pushArray-buttonAdd" />{" "}
                  <div>Thêm thông tin lần bán</div>
                </div>
              </>
            )}
          />
        </Grid>
      </Grid>
    </div>
  );
};